module.exports = __webpack_public_path__ + "img/ipad.f2121c07.jpg";